module.exports = __webpack_public_path__ + "img/checked02.000172d7.svg";